import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchNotifications, readNotifications } from "../../service/api";


export const getNotifications = createAsyncThunk(
    "profile/notification",
    async (params, { rejectWithValue }) => {
        try {
            const res = await fetchNotifications(params)
            console.log("notice", res?.data.data.finalResponse)
            return res?.data.data

        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const markReadNotifications = createAsyncThunk(
    "profile/read",
    async (params, { rejectWithValue }) => {
        try {
            const response = await readNotifications(params)
            console.log("read", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)




const notificationSlice = createSlice({
    name: "categories",
    initialState: {
        notifications: [],
        isLoading: false,
        actionLoader: false,
        error: null,

    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            //GET Notice
            .addCase(getNotifications.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getNotifications.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notifications = action.payload.finalResponse;
            })
            .addCase(getNotifications.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            //READ MARK
            .addCase(markReadNotifications.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(markReadNotifications.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(markReadNotifications.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

    }
})

export default notificationSlice.reducer